import { render } from "./tmIntroduce.vue?vue&type=template&id=66c86ed3"
import script from "./tmIntroduce.vue?vue&type=script&lang=js"
export * from "./tmIntroduce.vue?vue&type=script&lang=js"

import "./tmIntroduce.vue?vue&type=style&index=0&id=66c86ed3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__